<template>
    <v-container class="bg-surface-variant">
        <div class="d-flex flex-column mb-6 bg-surface-variant">
            <v-row no-gutters style="flex-wrap: nowrap;">
                <v-col>
                    <v-card elevation="2" outlined shaped>
                        <v-row justify="center">
                            <v-card-title class="text-h5">{{ title }}</v-card-title>
                        </v-row>
                        <v-row no-gutters>
                            <v-row no-gutters>
                                <v-col cols="1" xs="0" sm="0" md="2" class="flex-grow-0 flex-shrink-0"></v-col>
                                <v-col cols="10" xs="8" sm="8" md="8" class="flex-grow-0 flex-shrink-0">
                                    <v-card class="pa-2">
                                        <v-data-table :headers="headers" :items="items" :search="search">
                                            <template v-slot:[`item.actions`]="{ item }">
                                                <v-icon small class="mr-2"
                                                    @click="handleClick(item, 'pay')">mdi-play</v-icon>
                                            </template>
                                        </v-data-table>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </div>
        <div class="w-auto" v-show="isOpenModalidad">
            <MetodoPago ref="modalidad" @selection="receiveEmit" />
        </div>
        <div class="w-auto" v-show="isOpenModal">
            <CriptoModal ref="modalCripto" />
        </div>
        <div class="w-auto" v-show="isOpenModal">
            <AmazonModal ref="modal" />
        </div>
        <!-- <div class="w-auto" v-show="isOpenModal">
            <TronPayment ref="modalTron" />
        </div> -->

    </v-container>
</template>

<script>
import UserService from '../../services/user.service';
import EventBus from "../../common/EventBus";
// import URL_COINBASE from '../../services/direction';

import MetodoPago from '@/components/utils/SelectModalidadComponent.vue'
import CriptoModal from '@/components/utils/CriptoModalComponent.vue'
import AmazonModal from '@/components/amazon/AmazonModalComponent.vue'
// import TronPayment from '@/components/utils/TronPaymentComponent.vue'


export default {
    name: 'SuscripcionMenuComponent',
    components: {
        MetodoPago,
        CriptoModal,
        AmazonModal,
        // TronPayment
    },
    data() {
        return {
            
            title: "TIPOS DE SUSCRIPCIÓN",
            
            // Table
            headers: [
                { text: "Nombre", value: "nombre", align: "center" },
                { text: "Descripcion", value: "descripcion", align: "center" },
                { text: "Dias", value: "dias", align: "center" },
                { text: "Precio / $", value: "precio", align: "center" },
                { text: "Limite Bot", value: "limiteInversionPorBot", align: "center" },
                { text: 'Actions', value: 'actions', sortable: false, align: "center" }
            ],
            items: [],
            item: '',
            right: null,
            search: '',
            start: false,
            colors: "success",
            msgBtn: '',
            isOpenModal: false,
            isOpenModalidad: false,
            selected: '',
            // Params
            accion: '',
            idSuscripcion: '',

        };
    },
    computed: {},
    created() { },
    mounted() {
        let values = Object.values(this.$route.query)
        console.log(values)

        this.accion = values[0]
        if (this.accion === 'new') {
            this.idSuscripcion = 'new'
        }  else {
            this.idSuscripcion = values[1]
        }
        

        // if (this.$route.params.idSuscripcion !== null) {
        //     this.idSuscripcion = this.$route.params.idSuscripcion
        // }

        UserService.getTypes().then(
            response => {
                // console.log(response.data)
                this.loadData(response.data);
            },
            error => {
                this.content =
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString();
                if (error.response && error.response.status === 403) {
                    EventBus.dispatch("logout");
                }
            }
        );
    },
    methods: {
        loadData(data) {
            this.items = data;
        },
        handleClick(value, action) {
            switch (action) {
                case 'pay':
                    // console.log(value)
                    this.selected = value
                    
                    // console.log(this.selected)
                    this.openMenuPay(value)
                    // console.log(URL_COINBASE.URL_COINBASE)
                    // console.log(value.productId)
                    // window.location.href = URL_COINBASE.URL_COINBASE + value.productId
                    // window.open(URL_COINBASE.URL_COINBASE + value.productId, '_blank');
                    // UserService.getLinkPay(this.$store.state.auth.user.email, value.id).then(
                    //     response => {
                    //         console.log(URL_COINBASE)
                    //         // console.log(response.paymentIntent)
                    //         // window.location.href = response.paymentIntent
                    //     },
                    //     error => {
                    //         this.content =
                    //             (error.response && error.response.data && error.response.data.message) ||
                    //             error.message ||
                    //             error.toString();
                    //         // EventBus.dispatch("logout");
                    //     }
                    // );
                    break;
            }
        },
        receiveEmit(value) {
            this.$refs.modalidad.closeModal()
            if (value === 'cripto') {
                this.openModalCripto()
            } else {
                this.openModalAmazon()
            }
        },
        openMenuPay(value) {
            this.item = value
            this.$refs.modalidad.openModal()
        },
        openModalCripto() {
            // console.log(this.selected)
            // this.$refs.modalTron.openModal()
            this.$router.push("/tron/?accion=" + this.accion + "&suscripcion=" + this.idSuscripcion + '&tipo=' + this.selected.id);
            // this.$refs.modalCripto.openModal(this.item)
            // this.$refs.modalCripto.item = this.item
            // this.$refs.modalCripto.idSuscripcion = this.selected.id
            // this.$refs.modalCripto.tituloSuscripcion = this.selected.nombre
            // this.$refs.modalCripto.dias = this.selected.dias
            // this.$refs.modalCripto.precio = this.selected.precio
            // this.$refs.modalCripto.total = this.selected.precio
        },
        openModalAmazon() {
            this.$refs.modal.openModal(this.item)
            this.$refs.modalCripto.item = this.item
            this.$refs.modal.idTipoSuscripcion = this.selected.id
            this.$refs.modal.tituloSuscripcion = this.selected.name
            this.$refs.modal.tipo = this.selected.nivel
            this.$refs.modal.bots = this.selected.bots
            this.$refs.modal.meses = this.selected.meses
            this.$refs.modal.precio = this.selected.precio
            this.$refs.modal.total = this.selected.precio
            setTimeout(() => this.$refs.modal.chargeButton(), 500);
        },
    }
}
</script>